var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 24H0V0h24v24z","fill":"none","opacity":".87","key":0}),React.createElement("path",{"d":"M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z","key":1})]);
}

Chevron.defaultProps = {"viewBox":"0 0 24 24","fill":"black","width":"18px","height":"18px"};

module.exports = Chevron;

Chevron.default = Chevron;
